//##############################################################//
// PARA PRUEBAS EN LOCAL, COMENTAR LINEA 8 y DESCOMENTAR LINEA 9
// CAMBIAR localhost por la IP de la maquina donde se corre el API para pruebas con telefono usb
//##############################################################//
export const appEnv = import.meta.env.VITE_MODE;

export const BASE_API_APP_TMP = "/opt/apps/fishweb-api-v1/tmp/";
export const BASE_PATH_API =
  appEnv === "development"
    ? "http://localhost:8000"
    : "https://fishweb.salmonesdechile.com:8000";
export const BASE_PATH_API_INET =
  appEnv === "development"
    ? "http://localhost:8100"
    : "https://fishweb.salmonesdechile.com:8100";
export const BASE_PATH_REPOSITORIO = "http://172.27.1.19/";
export const BASE_PATH_UPLOAD_SOC_REPO =
  "http://172.27.1.19/srv/fishweb/solicitudes";
export const BASE_PATH_UPLOAD_OC_REPO =
  "http://172.27.1.19/srv/fishweb/ordenes";
export const CENTROS_OPERACIONES = [
  2, 6, 46, 161, 75, 9, 52, 95, 78, 32, 35, 86, 6, 43, 149, 38, 44, 50, 47, 84,
  10, 61, 41, 147, 65, 85, 13, 42, 56, 148, 139, 76, 59, 33, 39, 159, 2, 77, 40,
  34, 11, 160, 54, 91, 97, 57, 37, 8, 51, 151, 100, 65, 101, 102, 103, 104, 105,
  106, 107, 108, 109, 110, 111, 112, 113, 114, 119, 120, 121, 122, 123, 124,
  131, 132, 133, 139, 142, 144, 148, 149, 150, 151, 155, 158, 159, 160, 161,
  167,
];
//######### LOGIN ##########//
export const PATH_GET_INIT_DATA_USER_PROFILE = "/user-init-data";
//######### SECURITY #######//
export const STATIC_TOKEN_CONNECTION =
  "sRrAup0z^k+!W~t~u^=lme/Re&=^Sof8e.><q{4q@_G4ExVgXH`Kry2n|CS_Z";
//######### CONSTANT PARAMS ##########//
export const TIPO_DOCUMENTO_SOLICITUDES = 1;
export const TIPO_DOCUMENTO_ORDENES = 2;
//######### MENUS #########//
export const PATH_GET_MENUS = "/menu";
//######### DASHBOARD #########//
export const PATH_DATA_DASHBOARD_TUTORIAL =
  "/core/administracion/getVideoTutorial";

//##### INIT DATA #####//
export const PATH_GET_INIT_DATA = "/login/user-init-data";
export const PATH_GET_INIT_DATA_DEV = "/login/user-init-data-dev";
export const PATH_GET_INIT_DATA_ITEMS_ADQ = "/carga-inicial/items";
export const PATH_GET_INIT_DATA_CENTROS_COSTO = "/carga-inicial/centros-costo";
export const PATH_GET_INIT_DATA_PROVEEDORES = "/carga-inicial/proveedores";
export const PATH_GET_INIT_DATA_TIPOS_SOLICITUD =
  "/carga-inicial/tipos-documento";
export const PATH_GET_INIT_DATA_MESES = "/carga-inicial/meses";
export const PATH_GET_INIT_DATA_ESTADOS_OP =
  "/carga-inicial/estados-operacionales";
export const PATH_GET_INIT_DATA_TIPOS_MONEDA = "/carga-inicial/tipos-moneda";
export const PATH_GET_INIT_DATA_ESTADOS_SOLICITUD =
  "/carga-inicial/estados-solicitud";
export const PATH_GET_INIT_DATA_DOC_TRIBUTARIOS =
  "/carga-inicial/tipos-doc-tributarios";
export const PATH_GET_INIT_DATA_TIPOS_ITEMS_ADQ =
  "/carga-inicial/tipos-items-adquisicion";
export const PATH_GET_INIT_DATA_PARAMS = "/carga-inicial/parametros-generales";
//###### INIT DATA CONTABLES #####//
export const PATH_GET_INIT_DATA_CUENTAS_CONTABLES =
  "/carga-inicial/cuentas-contables";
export const PATH_GET_INIT_DATA_ITEMS_CONTABLES =
  "/carga-inicial/cuentas-contables-items";
export const PATH_GET_INIT_DATA_NATURALEZAS_CONTABLES =
  "/carga-inicial/cuentas-contables-items-naturalezas";
export const PATH_GET_INIT_DATA_ESTADOS_ORDENES =
  "/carga-inicial/estados-ordenes";
export const PATH_GET_INIT_DATA_USER_APROBADORES =
  "/carga-inicial/users-aprobadores";
export const PATH_GET_INIT_DATA_CONDICIONES_PAGO =
  "/carga-inicial/condiciones-pago";

//############# PRESPUESTOS ###################//
export const PATH_GET_PRESUPUESTOS = "/presupuestos";
export const PATH_POST_BUDGET = "/presupuestos/add";
export const PATH_POST_BUDGET_MONTH = "/presupuestos/add-meses";
export const PATH_GET_PPTO_DISPONIBLE_CC = "/presupuestos/disponible";

//############# ARCHIVOS ####################//
export const PATH_FILE_UPLOAD = "/files/upload";
export const PATH_FILE_DOWNLOAD = "/files/download";
export const PATH_FILE_DOWNLOAD_FOLDER = "/files/download-zip";
export const PATH_FILE_DELETE_ZIP = "/files/delete-zip";
export const PATH_FILE_UPLOAD_DOCUMENT = "/files/upload-document";

//############# SOLICITUDES ###################//
export const PATH_GET_SOLICITUDES = "/solicitudes";
export const PATH_GET_SOLICITUDES_DETALLES = "/solicitudes/details";
export const PATH_GET_SOLICITUD_DETALLE_ID = "/solicitudes/detail";
export const PATH_POST_NEW_SOLICITUDE = "/solicitudes/add";
export const PATH_POST_NEW_SOLICITUDE_DETAIL = "/solicitudes/add-detail";
export const PATH_DELETE_SOLICITUD = "/solicitudes/delete";
export const PATH_DELETE_SOLICITUD_DETALLE = "/solicitudes/delete-detail";
export const PATH_GET_PPTO_SOLICITADO_CC =
  "/solicitudes/presupuesto-solicitado";
export const PATH_GET_SOLICITUDE_APPROVALS_STATES =
  "/solicitudes/approvals-states";

export const PATH_GET_SOLICITUDES_COMPRA_BY_ESTADO =
  "/solicitudes/estado-rango";
export const PATH_GET_SOLICITUDES_COMPRA_BY_ESTADO_DETALLES =
  "/solicitudes/estado-rango-detalles";

export const PATH_GET_SIGN_SOLICITUDE_HISTORY =
  "/solicitudes/sign-approval-history";

//################## PURCHASE ORDERS ###################//
export const PATH_GET_ORDENES_COMPRA = "/ordenes-compra";
export const PATH_GET_ORDENES_COMPRA_DETALLES = "/ordenes-compra/details";
export const PATH_GET_ORDEN_COMPRA_DATA = "/ordenes-compra/data";
export const PATH_GET_ORDEN_COMPRA_DETALLE_ID = "/ordenes-compra/detail";
export const PATH_POST_NEW_ORDEN_COMPRA = "/ordenes-compra/add";
export const PATH_POST_NEW_ORDEN_COMPRA_DETAIL = "/ordenes-compra/add-detail";
export const PATH_DELETE_ORDEN_COMPRA = "/ordenes-compra/delete";
export const PATH_DELETE_ORDEN_COMPRA_DETALLE = "/ordenes-compra/delete-detail";
export const PATH_GET_PPTO_TOMADO_ORDENES_CC =
  "/ordenes-compra/presupuesto-tomado";
export const PATH_GET_ORDENES_COMPRA_APPROVALS_STATES =
  "/ordenes-compra/approvals-states";

export const PATH_GET_SIGN_ORDEN_HISTORY =
  "/ordenes-compra/sign-approval-history";

export const PATH_POST_ORDEN_EMITIDA = "/ordenes-compra/add-orden-emitida";
export const PATH_POST_ORDEN_VISTA_MARCA =
  "/ordenes-compra/add-orden-vista-marca";

//#################### UPDATES ########################//
export const PATH_PUT_UPD_SOLICITUDE = "/solicitudes/update-solicitude";
export const PATH_PUT_UPD_SOLICITUDE_DETAIL =
  "/solicitudes/update-solicitude-detail";
export const PATH_POST_SOLICITUDE_APPROVAL_STATE =
  "/solicitudes/add-approval-detail";

//################### UPDATE ORDENES ######################//
export const PATH_PUT_UPD_ORDEN_COMPRA = "/ordenes-compra/update-orden";
export const PATH_PUT_UPD_ORDEN_COMPRA_DETAIL =
  "/ordenes-compra/update-orden-detail";
export const PATH_POST_ORDENES_COMPRA_APPROVAL_STATE =
  "/ordenes-compra/add-approval-orden-detail";
export const PATH_PUT_ORDENES_STATE_GTE =
  "/ordenes-compra/update-orden-for-gte";

export const PATH_PUT_ORDEN_COMPRA_NULA = "/ordenes-compra/nule-orden";
//############### ###################//
export const PATH_GET_SUBTIPOS_DOC = "/carga-inicial/tipos-documento/subtipo";

//##################### SIGNATURES ##########################//

export const PATH_GET_DIGITAL_SIGN = "/digital-sign";
export const PATH_POST_NEW_DIGITAL_SIGN = "/digital-sign/add";
export const PATH_GET_VALID_DIGITAL_SIGN =
  "/digital-sign/validate-sign-solicitude";
export const PATH_GET_VALID_DIGITAL_SIGN_PURCHASE_ORDER =
  "/digital-sign/validate-sign-order";
export const PATH_POST_NEW_SIGN_APPROVAL_HIS_SOLICITUDE =
  "/digital-sign/add-sign-approval-history-solicitude";

export const PATH_POST_NEW_SIGN_APPROVAL_HIS_ORDER =
  "/digital-sign/add-sign-approval-history-order";

//############### ESTADISTICAS #################//
//##### SOLICITUDES #####//
export const PATH_GET_SOLICITUDES_STATISTICS_YEAR =
  "/solicitudes/statistics/year";
export const PATH_GET_SOLICITUDES_STATISTICS_MONTH =
  "/solicitudes/statistics/month";
export const PATH_GET_SOLICITUDE_PPTO_STATISTICS_YEAR =
  "/solicitudes/statistics/presupuesto-year";
export const PATH_GET_SOLICITUDE_PPTO_STATISTICS_MONTH =
  "/solicitudes/statistics/presupuesto-month";
export const PATH_GET_ALL_PPTO_SOLICITUDE_MONTHS =
  "/solicitudes/statistics/presupuesto-month-all";
export const PATH_GET_SOLICITUDES_STATISTICS_CENTROS =
  "/solicitudes/statistics-cost-center";
export const PATH_GET_STATISTICS_RECENT_SOLICITUDES =
  "/solicitudes/statistics-recents";

//##### ORDERS #####//
export const PATH_GET_PURCHASE_ORDERS_STATISTICS_YEAR =
  "/ordenes-compra/statistics/year";
export const PATH_GET_PURCHASE_ORDERS_STATISTICS_MONTH =
  "/ordenes-compra/statistics/month";
export const PATH_GET_PURCHASE_ORDERS_PPTO_STATISTICS_YEAR =
  "/ordenes-compra/statistics/presupuesto-year";
export const PATH_GET_PURCHASE_ORDERS_PPTO_STATISTICS_MONTH =
  "/ordenes-compra/statistics/presupuesto-month";
export const PATH_GET_ALL_PPTO_PURCHASE_ORDERS_MONTHS =
  "/ordenes-compra/statistics/presupuesto-month-all";
export const PATH_GET_ORDENES_STATISTICS_CENTROS =
  "/ordenes-compra/statistics-cost-center";
export const PATH_GET_STATISTICS_RECENT_ORDENES =
  "/ordenes-compra/statistics-recents";

// ######################### FINANZAS - CONTABILIDAD ############################# //

export const PATH_GET_ORDENES_FACTURAS_PAGOS = "/finanzas/facturas-pagos";

export const PATH_GET_ORDENES_FACTURAS_CENTROS =
  "/contabilidad/facturas-centros";

export const PATH_GET_SII_INVOICE = "/sii/consultar-dte";

export const PATH_GET_ORDENES_FACTURAS_PAGINATED = "/finanzas/paginated";

export const PATH_GET_DTE_PDF = "/finanzas/dte-pdf";

export const PATH_ADD_RECEPCION_DOCUMENTO = "/finanzas/add-recepcion-documento";

// Reportes read-only (dashboard finanzas): /finanzas/reportes/{resumen|proveedores|...}
export const PATH_GET_REPORTES_FINANZAS = "/finanzas/reportes";

// Reportes read-only (dashboards solicitudes / ordenes): /reports/{solicitudes|ordenes|ciclo|...}/...
export const PATH_GET_REPORTES = "/reports";

export const PATH_POST_ORDEN_COMPRA_ESTADO_INET =
  "/finanzas/update-orden-estado-inet";

//####### PPTO #######//
export const PATH_PPTO_STATISTICS_MONTH = "/presupuestos/statistics/month";
export const PATH_PPTO_STATISTICS_YEAR = "/presupuestos/statistics/year";
export const PATH_GET_LAST_PRICE_ITEM_SELECTED = "/presupuestos/last-price";
export const PATH_POST_LAST_PRICE_STOCK_ITEM =
  "/presupuestos/last-price-stock-item";

//############################ MAIL ############################//
export const PATH_SEND_EMAIL_NOTIFICATION = "/notifications/send-mail";
export const PATH_SEND_EMAIL_NOTIFICATION_ATTACH_REPO =
  "/notifications/send-mail-attach-repo-file";
export const PATH_GET_EMAILS_DESTINATARIES_SOL =
  "/solicitudes/emails-destinataries";
export const PATH_GET_EMAILS_DESTINATARIES_ORD =
  "/ordenes-compra/emails-destinataries";
export const PATH_GET_EMAIL_LOG_ORDENES_EMITIDAS =
  "/notifications/email-log/ordenes-emitidas";

//####################### INDICADORES ECONOMICOS ######################//
export const BASE_PATH_MINDICADOR_CL = "https://mindicador.cl/api/";
export const PATH_MINDICADOR_DOLAR_DIARIO = "dolar/";
export const PATH_MINDICADOR_UF_DIARIO = "uf/";
export const PATH_MINDICADOR_EURO_DIARIO = "euro/";

//##################### DATOS GENERALES ########################//
export const PATH_GET_DATOS_PROVEEDORES = "/proveedores";

//################### OPERACIONES CONTRA INET #######################/
export const PATH_ADD_ORDEN_COMPRA_INET = "/ordenes-compra/add";
export const PATH_ADD_ORDEN_COMPRA_DETALLE_INET = "/ordenes-compra/add-detail";
export const PATH_ADD_ORDEN_COMPRA_DETALLE_GLOSA_INET =
  "/ordenes-compra/add-glosa";
export const PATH_PUT_ORDEN_COMPRA_NULA_INET = "/ordenes-compra/nule-orden";
export const PATH_ADD_RECEPCION_SERVICIOS_INET = "/finanzas/add-recepcion";

export const NOTICIAS_BANNER = [
  {
    id: 1,
    version: "v2.4.1",
    tagType: "warning",
    category: "Nueva Funcionalidad Finanzas",
    title: "Recepción automatizada de servicios y actualización de estados OC.",
    description:
      "Finanzas puede generar una recepción de ordenes de tipo servicios de una forma más automatizada y controlada. Se marcan emitidas las OC.",
    date: "Septiembre 2026",
    badgeIcon: "pi pi-check-circle",
  },
  {
    id: 1,
    version: "v2.4.0",
    tagType: "success",
    category: "Nueva Solución",
    title: "Módulo de Finanzas / Contabilidad OC",
    description:
      "Búsqueda y seguimiento de facturación, recepciones, historial contable y estado de pagos, todo asociado a órdenes de compra.",
    date: "Septiembre 2026",
    badgeIcon: "pi pi-check-circle",
  },
  {
    id: 1,
    version: "v2.3.9",
    tagType: "info",
    category: "Sección de información de mejoras",
    title: "Últimas novedades de la aplicación",
    description: "Este banner muestra las últimas novedades de la aplicación.",
    date: "Agosto 2026",
    badgeIcon: "pi pi-check-circle",
  },
  {
    id: 1,
    version: "v2.3.8",
    tagType: "success",
    category: "Ordenes de compra de combustible",
    title: "Creación e integración de ordenes de compra de tipo combustible",
    description:
      "Se ha incluído toda la lógica requerida en la aplicación para el tratamiento de ordenes de compra de combustible.",
    date: "Agosto 2026",
    badgeIcon: "pi pi-check-circle",
  },
];
export const CENTRO_COSTO_GENERAL = 29;
export const CENTRO_COSTO_ADQUISICION = 22;
export const CENTRO_COSTO_ALIMENTOS_ADQUISICION = 30;
export const USUARIOS_CONFIRMACION_ORDENES = [65, 77, 86];
export const USUARIO_CONFIRMA_GTE_GENERAL = [81]; //Roberto
export const USUARIOS_CONFIRMA_ORDENES = [65];
export const USUARIOS_FINANZAS = [17, 62]; // 17, 62 Nataly nohemy ... Otros: 106, 36, 41, 86
export const USUARIO_TI = 86;
export const USUARIO_JEFE_ABASTECIMIENTO = 37;
export const USUARIOS_ADQUISICIONES = [67, 37, 59];
export const EMAIL_ADQUISICIONES = "adquisiciones@salmonesdechile.com";
export const GIRO_EMPRESA_SALMONES_DE_CHILE =
  "Producción, Comercio, Crianza, Elaboración y Envase de Productos Marinos en especial, el cultivo de salmones Pesca y extracción de especies marinas y su congelamiento. Industrialización, comercialización y exportación. Elaboración y comercialización de alimentos para peces y demás especies marinas. Inversiones en valores mobiliarios, sean acciones o bonos y muebles corporales e incorporales.";
export const DIRECCION_EMPRESA_SALMONES_DE_CHILE =
  "Casa Matriz: Janequeo 238 - Chonchi - Chile.";
export const TELEFONO_EMPRESA_SALMONES_DE_CHILE =
  "Teléfonos: (65) 2672204 - (65) 2672205 - (65) 2672267";
export const FECHA_CORTE_FIRMA_GERENTE = new Date("2026-04-01");
//################### CONSTANT FUNCTIONS #######################//
export const validateEmail = (email: string) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

export function parseNumberCommaFormatForOperations(n: any) {
  "use strict";
  n = n.replace(/\./g, "").replaceAll(",", ".");
  return parseFloat(n);
}

export function FORMAT_DATETIME_DDMMYYYY(date: string) {
  const dateTime = new Date(date);
  const year = dateTime.getFullYear();
  const month = dateTime.getMonth() + 1;
  const day = dateTime.getDate();

  return day + "/" + month + "/" + year;
}

export function FORMAT_DATETIME_DDMMYYYY_GUION(date: string) {
  const dateTime = new Date(date);
  const year = dateTime.getFullYear();
  const month = dateTime.getMonth() + 1;
  const day = dateTime.getDate();

  return day + "-" + month + "-" + year;
}

export const FORMAT_CURRENCY = (value: any) => {
  return value.toLocaleString("de-DE", {
    minimumFractionDigits: 4,
  });
};

export const FORMAT_CURRENCY_PESOS = (value: any) => {
  return value.toLocaleString("de-DE", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

export const FORMAT_CURRENCY_OTROS_NO_PESOS = (value: any) => {
  return value.toLocaleString("de-DE", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export const FORMAT_CURRENCY_AND_DOTS = (value: any) => {
  return value.toLocaleString("de-DE", {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
    useGrouping: true,
  });
};

export function decodeBase64Image(dataString: string) {
  let encodedImage = dataString.split(",")[1];
  return encodedImage;
}

export const getUserIp = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Error fetching IP address:", error);
    return "Unknown IP";
  }
};

export const SHOW_MSG_ACTION = (
  toast: any,
  severity: any,
  summary: any,
  detail: any,
  functionAction: any,
) => {
  toast.current.show({
    severity: severity,
    summary: summary,
    detail: detail,
    sticky: true,
    closable: false,
    content: (props: any) => (
      <div className="toastContent">
        <i
          className={
            props.message.severity === "success"
              ? "pi pi-check-circle"
              : props.message.severity === "error"
                ? "pi pi-times-circle"
                : "pi pi-info-circle"
          }
          style={{
            fontSize: "3rem",
            color:
              props.message.severity === "success"
                ? "#10B981"
                : props.message.severity === "error"
                  ? "#c70808"
                  : "#fca103",
          }}
        ></i>
        <div className="toastTitle">{props.message.summary}</div>
        <div className="toastMsg">{props.message.detail}</div>
        <button
          className="custom-buttonform"
          style={{ marginLeft: "1.5vw" }}
          onClick={() => {
            functionAction();
            toast.current.clear();
          }}
        >
          Aceptar
        </button>
      </div>
    ),
  });
};

export const showMsg = (
  toast: any,
  severity: any,
  summary: any,
  detail: any,
) => {
  toast.current.show({
    severity: severity,
    summary: summary,
    detail: detail,
    sticky: true,
    closable: false,
    content: (props: any) => (
      <div className="toastContent">
        <i
          className={
            props.message.severity === "success"
              ? "pi pi-check-circle"
              : props.message.severity === "error"
                ? "pi pi-times-circle"
                : "pi pi-info-circle"
          }
          style={{
            fontSize: "3rem",
            color:
              props.message.severity === "success"
                ? "#10B981"
                : props.message.severity === "error"
                  ? "#c70808"
                  : "#fca103",
          }}
        ></i>
        <div className="toastTitle">{props.message.summary}</div>
        <div className="toastMsg">{props.message.detail}</div>
        <button
          className="custom-buttonform"
          style={{ marginLeft: "1.5vw" }}
          onClick={() => {
            toast.current.clear();
          }}
        >
          Aceptar
        </button>
      </div>
    ),
  });
};

export const showWifiCheckingMsg = (
  toast: any,
  summary: any = "Comprobando conexión",
  detail: any = "Por favor, espera un momento...",
) => {
  toast.current.show({
    severity: "info",
    summary: summary,
    detail: detail,
    sticky: true, // Se mantiene fijo hasta que lo borres manualmente por código
    closable: false, // Quita la 'X' de cierre predeterminada
    content: (props: any) => (
      <div
        className="toastContent"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        {/* Ícono de Wifi con Clase de Animación Personalizada */}
        <i
          className="pi pi-wifi wifi-checking-animation"
          style={{
            fontSize: "3rem",
            color: "#3B82F6", // Azul de conectividad estándar (Tailwind blue-500)
            marginBottom: "1rem",
          }}
        ></i>

        <div
          className="toastTitle"
          style={{ fontWeight: "bold", marginBottom: "0.5rem" }}
        >
          {props.message.summary}
        </div>

        <div className="toastMsg" style={{ color: "#6B7280" }}>
          {props.message.detail}
        </div>
      </div>
    ),
  });
};

export const FILTER_ITEMS_BY_DOC_TYPE = (
  items: any[],
  docType: number,
  tiposItemsAdquisicion: any[],
) => {
  let filteredItems = items;

  if (docType !== 0) {
    // 1. Create a Set of valid IDs.
    // A Set allows for O(1) instant lookups instead of looping with .some()
    const validTipoIds = new Set(
      tiposItemsAdquisicion
        .filter((tipo) => tipo.id_sub_tipo_documento === docType)
        .map((tipo) => tipo.id),
    );

    // 2. Filter items instantly using the Set
    filteredItems = items.filter((item) =>
      validTipoIds.has(item.id_tipos_item_adquisicion),
    );
  }
  // 3. Omit properties using rest destructuring instead of JSON cloning and 'delete'
  return filteredItems.map(
    ({
      id_tipos_item_adquisicion,
      id_cuenta_contable_item_naturaleza,
      ...itemToKeep // This creates a shallow copy of the object minus the two keys above
    }) => itemToKeep,
  );
};

export const VALIDATE_FORMAT_ALPHA_NUMERIC_AND_DOT = (value: any) => {
  const clearedValue = value.replace(/<[^>]*>?/gm, " ").trim();

  if (/^[a-zA-Z0-9_\s.:°,áéíóúÁÉÍÓÚüÜñÑ()% \/-]+$/.test(clearedValue)) {
    return true;
  } else {
    return false;
  }
};

export const CONVERT_DATE_TO_INET_FORMAT = (dateStr: string) => {
  if (!dateStr) return "";

  // 1. Split "15-12-2025" into ["15", "12", "2025"]
  const [day, month, year] = dateStr.split("-");

  // 2. Reassemble as YYYY-MM-DD and add the time
  return `${year}-${month}-${day} 00:00:00.000`;
};

export const AUX_TIPO_DOCUMENTO_INET_CONVERT = (subTipoDoc: number) => {
  switch (subTipoDoc) {
    case 1:
      return 2; //SERVICIOS
    case 2:
      return 1; //STOCK
    case 3:
      return 3; //INVERSIONES //ACTIVO FIJO
    case 4:
      return 3; //ACTIVOS // DE PEDIDO ES 4 , DEJARLO 3
    case 5:
      return 2; //SERVICIOS
    case 6:
      return 1; //STOCK
    case 7:
      return 3; //INVERSIONES
    case 8:
      return 3; //ACTIVOS
    default:
      return subTipoDoc;
  }
};

export const AUX_CONDICION_PAGO_INET_CONVERT = (condicionPago: number) => {
  switch (condicionPago) {
    case 0:
      return 1;
    case 30:
      return 2;
    case 60:
      return 3;
    default:
      return condicionPago;
  }
};

export const VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE = (
  montoTotal: number,
  montoFirmaGte: number,
  tipoMonedaId: number,
  parametros: any[],
  tipoEstadoOperacion: number,
  subroganteVal: string | number | (string | number)[] | null,
): boolean => {
  const fechaHoy = new Date();

  try {
    // 1. VALIDACIÓN DE SUBROGANCIA (SALIDA INMEDIATA)
    // Manejamos si viene como "81,90,100" (string) o [81, 90] (array)
    let idsSubrogantes: string[] = [];

    if (Array.isArray(subroganteVal)) {
      idsSubrogantes = subroganteVal.map(String);
    } else if (subroganteVal) {
      idsSubrogantes = subroganteVal
        .toString()
        .split(",")
        .map((s) => s.trim());
    }

    if (idsSubrogantes.includes("81")) {
      console.log("✅ NO APLICA FIRMA CEO: Subrogancia ID 81 detectada.");
      return true; // Aborta y retorna true inmediatamente
    }

    // 2. VALIDACIÓN POR ESTADO Y FECHA
    // Nota: Asegúrate que FECHA_CORTE_FIRMA_GERENTE esté definida globalmente

    if (tipoEstadoOperacion === 3) {
      console.log(
        "⚠️ FIRMA GERENTE REQUERIDA: Asignación directa post-fecha corte.",
      );
      return false;
    }

    // 3. LÓGICA DE CONVERSIÓN DE MONEDA
    let factorConversion = 1;
    let codigoMoneda = "";

    switch (tipoMonedaId) {
      case 1: // PESO CHILENO
        break;
      case 2: // DOLAR
        codigoMoneda = "DOLAR_COT";
        break;
      case 3: // EURO
        codigoMoneda = "EURO_COT";
        break;
      case 40: // UF
        codigoMoneda = "UF_COT";
        break;
      default:
        return true;
    }

    if (codigoMoneda) {
      const param = parametros.find((p) => p.codigo === codigoMoneda);
      if (!param) {
        console.warn(
          `No se encontró cotización para ${codigoMoneda}, abortando firma.`,
        );
        return true;
      }
      factorConversion = parseFloat(param.valor);
    }

    const montoFinalEnPesos = montoTotal * factorConversion;

    // 4. VALIDACIÓN FINAL POR MONTO
    if (montoFinalEnPesos < montoFirmaGte) {
      return true;
    } else {
      console.log(
        `⚠️ FIRMA GERENTE REQUERIDA: Monto (${montoFinalEnPesos}) >= Límite (${montoFirmaGte})`,
      );
      return false;
    }
  } catch (error) {
    console.error(
      "❌ Error en VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE: ",
      error,
    );
    return true; // Por seguridad, si falla la lógica, asumimos true o manejamos según política
  }
};

export const AUX_VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE = (
  montoTotal: number,
  montoFirmaGte: number,
  tipoMonedaId: number,
  parametros: any[],
  tipoEstadoOperacion: number,
) => {
  const fechaHoy = new Date();

  try {
    if (tipoEstadoOperacion === 3) {
      //SI ES ASIGNACION DIRECTA FIRMA EL GERENTE
      console.log(
        "TIENE QUE FIRMAR EL GERENTE, PASA A ESTADO PENDIENTE GG POR SER ASIGNACION DIRECTA",
      );
      return false;
    }

    switch (tipoMonedaId) {
      case 1:
        //PESO CHILENO
        if (montoTotal < montoFirmaGte) {
          return true;
        } else {
          console.log("TIENE QUE FIRMAR EL GERENTE POR EL MONTO: ", montoTotal);
          return false;
        }
      case 2:
        //DOLAR
        let cotDolar = parametros.find(
          (param: { codigo: string }) => param.codigo === "DOLAR_COT",
        )?.valor;
        montoTotal = montoTotal * parseFloat(cotDolar);
        if (montoTotal < montoFirmaGte) {
          return true;
        } else {
          console.log(
            "TIENE QUE FIRMAR EL GERENTE POR EL MONTO CONVERTIDO DE DOLAR A PESOS: ",
            montoTotal,
          );
          return false;
        }
      case 3:
        //EURO
        let cotEuro = parametros.find(
          (param: { codigo: string }) => param.codigo === "EURO_COT",
        )?.valor;
        montoTotal = montoTotal * parseFloat(cotEuro);
        if (montoTotal < montoFirmaGte) {
          return true;
        } else {
          console.log(
            "TIENE QUE FIRMAR EL GERENTE POR EL MONTO CONVERTIDO DE EURO A PESOS: ",
            montoTotal,
          );
          return false;
        }

      case 40:
        //UF
        let cotUf = parametros.find(
          (param: { codigo: string }) => param.codigo === "UF_COT",
        )?.valor;
        montoTotal = montoTotal * parseFloat(cotUf);
        if (montoTotal < montoFirmaGte) {
          return true;
        } else {
          console.log(
            "TIENE QUE FIRMAR EL GERENTE POR EL MONTO CONVERTIDO DE UF A PESOS: ",
            montoTotal,
          );
          return false;
        }
      default:
        return true;
    }
  } catch (error) {
    console.error("Error en VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE: ", error);
    return true;
  }
};

export const FORMAT_TEXT_FOR_INET = (str: string) => {
  if (!str) return "";

  return str
    .replace(/<div[^>]*>/gi, " ") // Reemplaza <div ...> por un espacio
    .replace(/<\/div>/gi, "") // Elimina los </div>
    .replace(/<br\s*\/?>/gi, " ") // Reemplaza <br> por espacio si existen
    .replace(/&nbsp;/g, " ") // Quita espacios en blanco de HTML
    .replace(/\s+/g, " ") // Colapsa espacios múltiples
    .trim();
};

export const DETECT_BROWSER = () => {
  const userAgent = navigator.userAgent;
  if (userAgent.includes("Edg")) {
    return "Edge";
  } else if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
    return "Opera";
  } else if (userAgent.includes("Chrome")) {
    return "Chrome";
  } else if (userAgent.includes("Firefox")) {
    return "Firefox";
  } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
    return "Safari";
  } else if (userAgent.includes("Trident") || userAgent.includes("MSIE")) {
    return "IE";
  }

  return "Unknown Browser";
};

export const FORMAT_THOUSANDS = (number: number): string => {
  if (number === null || number === undefined) return "0";

  return new Intl.NumberFormat("es-CL", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(number);
};

export const IS_MOBILE = () => {
  // 1. Check if the screen is physically small
  const isSmallScreen = window.innerWidth <= 991;

  // 2. Check if the device primary input is a finger (Mobile/Tablet)
  const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;

  // If it's a small screen OR a touch device, treat as mobile
  return isSmallScreen || isTouchDevice;
};

export const VALIDATE_HIGH_AMOUNT_ORDERS = (
  montoTotal: number,
  tipoMonedaId: number,
  parametros: any[],
): boolean => {
  let codigoMoneda = "";
  let factorConversion = 1;

  switch (tipoMonedaId) {
    case 1: // PESO CHILENO
      break;
    case 2: // DOLAR
      codigoMoneda = "DOLAR_COT";
      break;
    case 3: // EURO
      codigoMoneda = "EURO_COT";
      break;
    case 40: // UF
      codigoMoneda = "UF_COT";
      break;
    default:
      return true;
  }

  if (codigoMoneda.length > 0) {
    const param = parametros.find((p) => p.codigo === codigoMoneda);
    if (!param) {
      console.warn(
        `No se encontró cotización para ${codigoMoneda}, abortando firma.`,
      );
      return true;
    }
    factorConversion = parseFloat(param.valor);
  }

  const montoFinalEnPesos = montoTotal * factorConversion;

  if (montoTotal > montoFinalEnPesos) {
    return true;
  } else {
    return false;
  }
};

export const GetHttpErrorMessage = (error: any): string => {
  const status = error?.response?.status;
  const backendMsg = error?.response?.data?.message;

  // 1. Format backend message (handles array from class-validator or string)
  let detail = "";
  if (Array.isArray(backendMsg)) {
    detail = backendMsg.join(". ");
  } else if (typeof backendMsg === "string") {
    detail = backendMsg;
  } else if (error?.message) {
    detail = error.message;
  }

  // 2. Map specific status codes with custom fallbacks
  switch (status) {
    case 400:
      return detail || "Solicitud incorrecta o parámetros inválidos.";
    case 404:
      return detail || "El recurso o la orden solicitada no fue encontrada.";
    case 500:
      return detail || "Error interno del servidor al procesar la solicitud.";
    default:
      return detail || "Ocurrió un error inesperado de comunicación.";
  }
};
